import countriesLib from "i18n-iso-countries";
import bnLocale from "i18n-iso-countries/langs/bn.json";
import enLocale from "i18n-iso-countries/langs/en.json";
import esLocale from "i18n-iso-countries/langs/es.json";
import idLocale from "i18n-iso-countries/langs/id.json";
import kkLocale from "i18n-iso-countries/langs/kk.json";
import ptLocale from "i18n-iso-countries/langs/pt.json";
import ruLocale from "i18n-iso-countries/langs/ru.json";

// i18n-iso-countries ships a complete name set for every supported locale, so
// country display names stay localized independently of which subset the
// backend returns — the list of selectable countries never changes by language.
countriesLib.registerLocale(enLocale);
countriesLib.registerLocale(ruLocale);
countriesLib.registerLocale(kkLocale);
countriesLib.registerLocale(bnLocale);
countriesLib.registerLocale(idLocale);
countriesLib.registerLocale(ptLocale);
countriesLib.registerLocale(esLocale);

/** Localized country name, falling back to English then the raw code. */
export function getCountryName(code: string, locale: string, fallback?: string): string {
  return countriesLib.getName(code, locale) ?? countriesLib.getName(code, "en") ?? fallback ?? code;
}
